(function ($) {


const Init = (() => {

  // settings
  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      form         = {},
      formMethod   = {},
      timer        = {},
      wp           = {},
      iscroll      = {},
      loading      = {},
      totop        = {},
      scrollbar    = {},
      canvas       = {},
      tab          = {},
      favorite     = {},
      accordion    = {},
      modal        = {},
      megamenu     = {},
      pages        = {};
  
  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : $('.js-header'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  website.shiftPoint = website.breakpoint.tb;
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  pages = {
    common  : [],
    top     : [],
    recruit : [],
  }
  

  //modules
  // サニタイズ関数
  function sanitizing(str){
    var before = new Array('&','"',"'","<",">","\n","\t","\\n");
    var after = new Array('&amp;','&quot;','&rsquo;',"&lt;","&gt;","<br />"," ","<br />");
    for( var i=0; i < before.length; i++ )
      str = str.replace(new RegExp(before[i],'g'), after[i]);
    return str;
  };
  
  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth  = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.ua        = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  const Modules = {
  
    init() {
      mod = {
        targetSmooth    : 'js-scroll',
        targetTotop     : 'js-totop',
        smoothSpeed     : 600,
  
        targetAlign     : 'js-align',
        targetAlignList : [],
        alignAddClass   : 'c-alignheight',
  
        targetOfi       : '.js-ofi .ofi',
  
        targetPagenavi  : 'js-pagenavi',
  
        targetDateField : 'js-datepicker',
  
        targetPullTrg   : 'js-pulldown',
        targetPullConts : 'js-pulldown_conts',
  
        confirmTrg      : 'js-confirmMsg',
  
        alertTrg        : 'js-alertMsg',
  
        removeTrg       : 'js-remove',
  
      };
  
      let alignList = document.querySelectorAll('.' + mod.targetAlign);
      mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      // this.tabBtn();
      this.modalBtn();
      this.pulldown();
      this.confirmMessage();
      this.alertMessage();
  
      objectFitImages(mod.targetOfi);
      Stickyfill.add('.js-sticky');
    },
  
    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#") ? 'html' : href ),
            position;
        if( website.headTag.css('position') == 'fixed' ){
          shift    = ( (href != "#") ) ? website.headTag.outerHeight() : 0
        }else{
          shift    = 50;
        }
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
        return false;
      });
    },
  
    modalBtn() {
      $('.'+mod.targetModalOpen).on('click',function(){
        $('body').addClass('is-modalOpen');
        let target = $(this).attr('href');
        $(target).fadeIn();
        return false;
      });
      $('.'+mod.targetModalClose).on('click',function(){
        $('body').removeClass('is-modalOpen');
        $(this).closest('.'+mod.targetModal).fadeOut();
        return false;
      });
    },
  
    alignHeight() {
      let alignHeight  = 0;
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(mod.alignAddClass);
        alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
        target.classList.remove(mod.alignAddClass);
      });
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = alignHeight + 'px';
      });
    },
  
    pulldown (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+ mod.targetPullTrg).hover(
          function(){
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetPullConts).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetPullConts).removeClass('is-act').stop().slideUp();
          }
        )
      } else{
        $('.'+mod.targetPullTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetPullTrg).find('.'+mod.targetPullConts).toggleClass('is-act').stop().slideToggle();
          if(!$(this).parent('.'+mod.targetPullTrg).hasClass('is-act')){
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
            return false;
          }else{
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
          }
        });
      }
    },
  
    confirmMessage() {
      if( $('.' + mod.confirmTrg ).length ){
        $('.' + mod.confirmTrg ).on('click', function(){
          let message = $(this).attr('data-confirm-message'),
              redirect = $(this).attr('data-url');
          let result = window.confirm(message);
  
          console.log(result);
          if( result ){
            window.location.href = redirect;
          }
        });
      }
    },
  
    alertMessage() {
      if( $('.' + mod.alertTrg ).length ){
        $('.' + mod.alertTrg ).on('click', function(){
          let message = $(this).attr('data-alert-message');
          alert(message);
        });
      }
    },
    removeElement() {
      $('.'+mod.removeTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).remove();
        return false;
      });
    },
  }
  
  const DrawerMenu = {
  
    init() {
      drawer = {
        panel     : 'js-so_panel',
        menu      : 'js-so_menu',
        duration  : 10,
        // openclass : 'slideout-open',
        toggleList: '#js-so_toggle',
        closeList : '#js-so_panel, #js-so_menu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });
  
      let nodeList = document.querySelectorAll(drawer.toggleList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });
  
      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },
  
  }
  
    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  
  const Slick = {
  
    init() {
      this.topKey();
    },
  
    topKey() {
      if($('.js-kv').length){
        let autospeed = 5000;
        $('.js-kv').slick({
          fade: true,
          autoplay: true,
          autoplaySpeed: autospeed,
          speed: 1000,
          cssEase: 'linear',
          arrows: false,
          dots: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              // breakpoint: website.breakpoint.ss,
              // settings: {
              //   dots: false,
              // }
  
            },],
        });
      }
    },
  
    init() {
      $('.js-slide').slick({
        autoplay: false,
        speed: 900,
        slideToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        asNavFor: '.js-slide-thumb',
      });
      $('.js-slide-thumb').slick({
        infinite: false,
        asNavFor: '.js-slide',
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 900,
        slideToScroll: 1,
        slidesToShow: 5,
        arrows: false,
        // asNavFor: '.js-slide',
        focusOnSelect: true,
      });
    }
  
  }
  
  const Megamenu = {
  
    init() {
      megamenu = {
        wrapElm     : '.js-megaWrap',
        trgElm      : '.js-megaTrg',
        contElm     : '.js-megaCont',
        overlayElm  : '.js-megaOverlay',
      }
      this.action();
    },
    action(){
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        if( website.winWidth < website.breakpoint.tb){
          $(megamenu.trgElm).children('a').on('click',function(){
            if($(this).hasClass('is-act')){
              $(this).removeClass('is-act');
              $(this).siblings(megamenu.contElm).removeClass('is-act').stop().slideUp();
            }else{
              $(this).addClass('is-act');
              $(this).siblings(megamenu.contElm).addClass('is-act').stop().slideDown();
            }
          });
        }else{
          $(megamenu.trgElm).hover(
            function(){
              $(this).find(megamenu.contElm).addClass('is-act').fadeIn();
              $(this).find(megamenu.overlayElm).addClass('is-act').fadeIn();
  
            },
            function(){
              $(this).find(megamenu.contElm).removeClass('is-act').fadeOut();
              $(this).find(megamenu.overlayElm).removeClass('is-act').fadeOut();
            }
          );
        }
      }
    },
    close() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        $(megamenu.contElm).removeClass('is-act').stop().slideUp(100).siblings('a').removeClass('is-act');
      }
    },
    adjust() {
      if( $(megamenu.trgElm).length && $(megamenu.contElm).length ){
        let positionY = website.headTag.outerHeight();
        $(megamenu.contElm).css('top', positionY+'px');
      }
    }
  }
  
  const Totop ={
    init(){
      totop = {
        targetClass : '.js-totop',
        speed       : 600,
      }
      if($(totop.targetClass).length){
        this.check();
        this.action();
      }
    },
    check(){
      if( website.scrollY > 100 ){
        $( totop.targetClass ).addClass('is-act').fadeIn(400);
      }else{
        $( totop.targetClass ).removeClass('is-act').fadeOut(400);
      }
    },
    action(){
      $( totop.targetClass ).on('click',function(){
        $('body,html').animate({scrollTop: 0}, totop.speed, 'swing');
        return false;
      });
    }
  }
  
  const Timer = {
    init() {
      timer = {
        targetClass : '.js-timer',
      };
      this.check();
    },
    check() {
      if($(timer.targetClass).length){
        $(timer.targetClass).hide();
        $(timer.targetClass).each(function(){
          let startTime   = new Date($(this).data('start')),
              endTime     = new Date($(this).data('end')),
              currentTime = new Date();
          if(startTime <= currentTime && currentTime <= endTime){
            $(this).show();
            return false;
          }
        });
      }
    }
  }
  
  const Accordion = {
  
    init() {
      accordion = {
        toggleElm : '.js-accordion',
        openElm   : '.js-accordionOpen',
        closeElm   : '.js-accordionClose',
      };
      this.toggle();
      this.open();
      this.close();
    },
  
    toggle() {
      if($(accordion.toggleElm).length){
        $(accordion.toggleElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              return false;
            } else {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              return false;
            }
          }else{
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
            } else {
              $(this).addClass(website.act).next().stop().slideDown();
            }
          }
        });
      }
    },
    open() {
      if($(accordion.openElm).length){
        $(accordion.openElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(target).stop().slideDown();
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).addClass(website.act);
              $(this).addClass(website.act).next().stop().slideDown();
              $(this).hide();
            }
          }
        });
      }
    },
    close() {
      if($(accordion.closeElm).length){
        $(accordion.closeElm).on('click', function(){
          let target = $(this).attr('data-accordion-content');
          if( target && $(target).length){
            if ( $(this).hasClass(website.act) ) {
              $(this).removeClass(website.act);
              $(target).stop().slideUp('fast');
              $(this).hide();
              return false;
            }
          }else{
            if ( !$(this).hasClass(website.act) ) {
              $(this).removeClass(website.act).next().stop().slideUp('fast');
              $(this).hide();
            }
          }
        });
      }
    }
  
  }
  
  const Form = {
    init(){
      form ={
        targetID        : '#js-mailform',
        rowElm          : '.js-form_item',
        inputElm        : '.js-form_input',
        confirmElm      : '.js-form_confirm',
        speed           : 600,
        headHeight      : 50,
        confirmBtn      : '#js-btn_confirm',
        backBtn         : '#js-btn_back',
  
        radioResetTrg   : '.js-radio_reset',
        checkboxResetTrg   : '.js-check_reset',
        radioToggleTrg  : '.js-radio_toggle',
        checkboxToggleTrg  : '.js-check_toggle',
        fileElm         : '.js-inputFile',
        unsetFileTrg    : '.js-unsetFile',
      }
      this.check();
      this.radioReset();
      this.checkboxReset();
      this.radioToggle();
      this.checkboxToggle();
      this.inputFileMethod();
    },
    check(){
      if($(form.targetID).length){
        var position = $(form.targetID).offset().top - form.headHeight;
        $(form.targetID).prepend('<input type="hidden" name="javascript_action" value="true">');
      }
  
      // 確認用エレメント非表示
      $(form.rowElm).each(function(){
        $(this).children(form.confirmElm).css('display', 'none');
      });
  
      // エラーメッセージ
      $.extend($.validator.messages, {
        required: '必須項目です。',
        email: 'メールアドレスの形式が正しくありません。',
        postal: '郵便番号の形式が正しくありません。',
        alphanum: '半角英数字で入力してください。',
        alpha: '半角英字で入力してください。',
        phone: '半角数字と「-」のみ使用できます。',
        equalTo: '同じ値を入力してください。',
        number: '半角数字で入力してください。',
        digits: '半角数字で入力してください。',
        url: 'URLの形式が正しくありません。',
        date: '日付の形式が正しくありません。',
        minlength: $.validator.format( "最低 {0} 文字以上で入力してください。" ),
        maxlength: $.validator.format( "最大 {0} 文字以下で入力してください。" ),
        min: $.validator.format( "{0} より大きな数にしてください。" ),
        max: $.validator.format( "{0} より小さな数にしてください。" ),
        step: '{0} の倍数を入力してください。',
        kana: '全角ひらがな、カタカナで入力してください。',
        hiragana: '全角ひらがなで入力してください。',
        katakana: '全角カタカナで入力してください。',
      });
  
      // バリデーションルール
      var methods = {
        postal: function(value, element){
          return this.optional(element) || /^[0-9]{3}-?[0-9]{4}$/.test(value);
        },
        alphanum: function(value, element){
          return this.optional(element) || /^[a-zA-Z0-9_]+$/.test(value);
        },
        alpha: function(value, element){
          return this.optional(element) || /^[a-zA-Z]+$/.test(value);
        },
        phone: function(value, element){
          return this.optional(element) || /^[0-9\-\ ]+$/.test(value);
        },
        kana: function(value, element){
          return this.optional(element) || /^[ぁ-んァ-ヶー　\ ]+$/.test(value);
        },
        hiragana: function(value, element){
          return this.optional(element) || /^[ぁ-んー　\ ]+$/.test(value);
        },
        katakana: function(value, element){
          return this.optional(element) || /^[ァ-ヶー　\ ]+$/.test(value);
        },
      };
  
      $.each(methods, function(key){
        $.validator.addMethod(key, this);
      });
  
      // バリデーション設定
      $(form.targetID).validate({
        rules : {
          'お問い合わせ種別' : {
            required: true
          },
          'お問い合わせ内容' : {
            required: true,
          },
          '会社名・学校名' : {
            required: true
          },
          '氏名' : {
            required: true,
          },
          'メールアドレス' : {
            required: true,
            email: true
          },
          '電話番号' : {
            required: true,
            phone: true,
            minlength: 10,
            maxlength: 14
          },
          'プライバシーポリシー[]' : {
            required: true,
            minlength : 1,
          },
        },
        messages :{
          'プライバシーポリシー[]': {
            required : '必須項目です',
          }
        },
        errorPlacement: function(error, element) {
          key = element.attr("name");
          if(
            key == 'お問い合わせ種別' ||
            key == 'お問い合わせ内容' ||
            key == '会社名・学校名' ||
            key == '所属' ||
            key == '氏名' ||
            key == 'メールアドレス' ||
            key == '電話番号' ||
            key == 'プライバシーポリシー[]'
          ) {
            var str = key.replace(/\[\d*\]/g, '');
            error.appendTo($("#" +str+ "_error"));
          } else{
            error.insertAfter(element);
          }
        }
      });
  
      // 入力内容チェック
      $(form.confirmBtn).on('click', function(){
        check = $(form.targetID).valid();
        if(check){
          $(form.rowElm).each( function(){
            var iInput   = $(this).children(form.inputElm);
            var iConfirm = $(this).children(form.confirmElm);
            if ( iInput.length ) {
              if ( iInput.hasClass('-check') ) {
                var chText = '';
                iInput.find('input').each( function( index, element ) {
                  if ( $(this).prop('checked') == true ) {
                    if ( chText != '' ) { chText = chText + '、'; }
                    chText = chText + sanitizing($(this).val());
                    iConfirm.html( chText );
                  }
                });
              } else {
                var iInputTag = iInput.find('input,select,textarea');
  
                if ( iInputTag.length ) {
                  var iVal = iInputTag.val();
                  if ( typeof iVal !== 'undifined' ) {
                    iConfirm.html( sanitizing(iVal) );
                  }
                }
              }
            }
  
            iInput.css('display', 'none');
            if ( iConfirm.hasClass('-iblock') ) {
              iConfirm.css('display', 'inline-block');
            } else {
              iConfirm.css('display', 'block');
            }
          });
        }
  
        position = $(form.targetID).offset().top - form.headHeight;
        $('body,html').animate({scrollTop:position}, form.speed, 'swing');
        return false;
  
      });
      // バック処理
  
      $(form.backBtn).on('click', function(){
        $(form.rowElm).each( function(){
          var iInput   = $(this).children(form.inputElm);
          var iConfirm = $(this).children(form.confirmElm);
          if ( iInput.hasClass('-iblock') ) {
            iInput.css('display', 'inline-block');
          } else {
            iInput.css('display', 'block');
          }
          iConfirm.css('display', 'none');
        });
  
        position = $(form.targetID).offset().top - form.headHeight;
        $('body,html').animate({scrollTop:position}, form.speed, 'swing');
        return false;
      });
    },
    radioReset(){
      $(form.radioResetTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).find('input[type="radio"]').prop('checked', false);
      });
    },
    checkboxReset(){
      $(form.checkboxResetTrg).on('click',function(){
        let target = $(this).data('target');
        $(target).find('input[type="checkbox"]').prop('checked', false);
      });
    },
    radioToggle(){
      $(form.radioToggleTrg).on('change',function(){
        let key = $(this).attr('name'), val, target, trg_val;
        val = $('[name="'+key+'"]:checked').val();
        trg_val = $('[name="'+key+'"]').data('toggle-value');
        target = $('[name="'+key+'"]').data('toggle-target');
        if(val == trg_val){
          $(target).removeClass('is-disabled').find('input,select,textarea').prop('disabled', false);
        }else{
          $(target).addClass('is-disabled').find('input,select,textarea').prop('disabled', true);
          $(target).find('input[type="checkbox"],input[type="radio"]').prop('checked',false);
          $(target).find('option').prop('selected',false);
          $(target).find('input:not([type="checkbox"]):not([type="radio"]), textarea').val('');
        }
      });
    },
    checkboxToggle(){
      $(form.checkboxToggleTrg).on('change',function(){
        let target = $(this).data('toggle-target');
        if($(this).prop('checked')){
          $(target).removeClass('is-disabled').find('input,select,textarea').each(function(){
            if($(this).parent('.js-toggle_check_fields,.js-toggle_radio_fields').length == 0){
              $(this).prop('disabled', false);
            }
          });
        }else{
          $(target).addClass('is-disabled').find('input,select,textarea').prop('disabled', true);
          $(target).find('input[type="checkbox"],input[type="radio"]').prop('checked',false);
          $(target).find('option').prop('selected',false);
          $(target).find('input:not([type="checkbox"]):not([type="radio"]), textarea').val('');
        }
      });
    },
    inputFileMethod() {
      $(form.fileElm).on('change',function(){
        if($(this).val()){
          $(this).siblings(form.unsetFileTrg).show();
        }
      });
      $(form.unsetFileTrg).on('click',function(){
        $(this).siblings(form.fileElm).val('');
        $(this).hide();
      });
    },
  
  }
  


  // OFF
  // ./inc/_loading.js
  // ./inc/_pagescroll.js
  // ./inc/_parallax.js
  // ./inc/_wordpress.js
  // ./inc/_form.js
  // ./inc/_favorite.js
  // ./inc/_modal.js


  // page
  const BasicPage = {
    init() {
      basic = {
        contentWrap : '.js-wrapper',
      };
      this.headerCheck();
    },
  
    headerCheck(){
      if(website.scrollY > 100){
        website.headTag.addClass('is-fixed');
      }else{
        website.headTag.removeClass('is-fixed');
      }
    },
  }
  
  const TopPage = {
  
    init() {
      pages.top = {
        marqueeElm : '.js-marquee',
        kvSlideElm : '.js-kvSlide',
      }
      this.update();
    },
    update() {
      $(pages.top.kvSlideElm).on('init',function(){
        $('.slick-current').addClass('is-anime');
      }).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        speed: 1000,
        autoplaySpeed: 4000,
        autoplay: true,
        draggable: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipe: true,
      }).on({
        beforeChange: function(event, slick, currentSlide, nextSlide){
          $(".slick-slide", this).eq(currentSlide).addClass('is-prev');
          $(".slick-slide", this).eq(nextSlide).addClass('is-anime');
        },
        afterChange: function() {
          $(".is-prev", this).removeClass("is-prev is-anime");
        }
      });
    },
  
  }
  
  const Recruit = {
  
    init() {
      pages.recruit = {
        openTrgElm    : '.js-modalOpen',
        closeTrgElm   : '.js-modalClose',
        slideElm      : '.js-modalSlide',
        modalElm      : '.js-modalCont',
      };
      this.modalSlideInit();
      this.modalOpen();
      this.modalClose();
    },
    modalOpen() {
      $(pages.recruit.openTrgElm).on('click',function(){
        let target = $(this).data('modal'),
            idx    = $(pages.recruit.slideElm).find('[data-modal-content="'+target+'"]').index();
        $(pages.recruit.modalElm).show();
        $(pages.recruit.slideElm).slick('slickGoTo',idx,true)
        $(pages.recruit.slideElm).slick('setPosition');
      });
    },
    modalClose(){
      $(pages.recruit.closeTrgElm).on('click',function(){
        $(pages.recruit.modalElm).hide();
      });
    },
    modalSlideInit(){
      $(pages.recruit.slideElm).slick({
        fade : true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        speed: 1000,
        autoplay: false,
        draggable: false,
        pauseOnFocus: true,
        pauseOnHover: true,
        swipe: false,
        responsive: [
          {
            // breakpoint: website.breakpoint.ss,
            // settings: {
            //   arrows: false,
            //   dots: true,
            // }
          },],
      });
    }
  }
  



  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        // Wordpress.init();
      }
    },

    set() {
      Modules.init();
      DrawerMenu.init();
      // Wordpress.init();
      // PageScroll.init();
      // Parallax.init();
      Megamenu.init();
      Accordion.init();
      BasicPage.init();      
      Slick.init();


      if ( website.page == 'top' ) {
        TopPage.init();
      } else if( website.page  == 'recruit' ) {
        Recruit.init();
      } else if( website.page  == 'contact' ) {
        Form.init();
      }

      WinLoad.add( Animation.check );
      WinLoad.add( BasicPage.headerCheck );
      // WinLoad.add( Iscroll.check );

      WinResize.add( Modules.iosCheck );
      WinResize.add( Modules.deviceCheck );

      WinResize.add( BasicPage.headerCheck );

      WinScroll.add( Animation.check );
      WinScroll.add( BasicPage.headerCheck );
      // WinScroll.add( Totop.check );
      // WinScroll.add( Iscroll.check );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
